import type React from 'react';

import type { Dayjs } from '@/js/libs/dayjs';

import { DATE_FORMAT } from 'src/constants.ts';

export interface IDate {
  value: Dayjs | undefined;
  format?: string;
  className?: string;
}

const Date: React.FC<IDate> = ({ value, format = DATE_FORMAT, className }) => (
  <div className={className}>{!!value && value.format(format)}</div>
);

export default Date;
